import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: { id: 'G-T2G20V465N' }
})

// trueにしておくと、コンソールがより多く出てくる
Vue.config.productionTip = false

// 開発するときだけコメントアウト外す。chromeの拡張機能が使える
// Vue.config.devtools = true

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
